import SupportWidget from '@dtwince/support-widget';
import { fetchSupportToken } from '../api/support';

// 编辑器内客服入口：匿名走设备指纹；已登录用户经一次性 supportToken 带 dtwin 身份档案
const env = (import.meta as unknown as { env?: Record<string, string | boolean | undefined> }).env ?? {};
const apiBase =
  (env.VITE_SUPPORT_API_BASE as string | undefined) ||
  // 生产营销 API 同源于 www.dtwince.com（api.dtwince.com 未配置 DNS，曾导致挂件 Failed to fetch）
  (env.DEV ? 'http://localhost:3100' : 'https://www.dtwince.com');
const siteBase =
  (env.VITE_MARKETING_SITE_BASE as string | undefined) ||
  (env.DEV ? 'http://localhost:3200' : 'https://www.dtwince.com');

export default function SupportWidgetMount() {
  return (
    <SupportWidget
      apiBase={apiBase}
      source="editor"
      marketingSiteBase={siteBase}
      fingerprintKey="dtwin.support.fp.editor"
      getSupportToken={async () => {
        try {
          return (await fetchSupportToken()).token;
        } catch {
          return undefined; // 未登录/接口异常 → 匿名访客通道
        }
      }}
    />
  );
}
